import { createWithEqualityFn } from 'zustand/traditional'

import { createJSONStorage, persist } from 'zustand/middleware'
import { persistStorage } from '@/shared/state/dataBase/persistStorage'

export interface IItemDetails {
    productId: string | null | undefined
    assetType: string | null | undefined
    id: string | null | undefined
    uri: string | null | undefined
    customPlayer: string | null | undefined
    imageUrl: string | null | undefined
    title?: string | null | undefined
}

export interface WebState {
    selectedWeb: IItemDetails | null

    setSelectedWeb: (web: IItemDetails | null) => void
    clearWebStore: () => void
}

export const useWebStore = createWithEqualityFn<WebState>()(
    persist(
        (set) => ({
            selectedWeb: null,

            setSelectedWeb: (web: IItemDetails | null) => {
                set(() => ({
                    selectedWeb: web,
                }))
            },
            clearWebStore: () =>
                set(() => ({
                    selectedWeb: null,
                })),
        }),

        {
            name: 'web-storage',
            storage: createJSONStorage(() => persistStorage),
        }
    )
)
